'use strict';

var loader = require('./loader');
(function () {
  var myo = {

    /**
     * Called by addToCollection() method and takes 
     * the returned image from the getProduct() call
     * and adds it to the summary cell.
     */
    addImageToSummary: function addImageToSummary(imgUrl, title, handle) {
      var summaryBar = document.querySelector('.selection-thumbs');
      var newImage = document.createElement('div');
      var imgHtml = '<img src="' + imgUrl + '" alt="' + title + '"/><a class="remove-selection" data-handle="' + handle + '"></a>';
      newImage.classList = 'selection-item selected';
      summaryBar.appendChild(newImage);
      newImage.innerHTML = imgHtml;
    },

    /**
     * Conditional check at the beginning of each
     * recursive addNextProduct() method call
     * to ensure we don't get stuck in an 
     * infinite loop.
     */
    addAllToCart: function addAllToCart() {
      if (myo.collection.length >= 1) {
        var product = myo.collection.shift();
        myo.addNextProduct(product);
      } else {
        myo.clearCollection();
        myo.getCart();
      }
    },

    /** 
     * recursive fetch request to fit into the 
     * synchronous requirement of the Shopify
     * AJAX API. Tied to the addAllToCart() method
     */
    addNextProduct: function addNextProduct(product) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(product)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        myo.addAllToCart();
      }).catch(function (err) {
        alert('Uh oh! Something went wrong. Please try again.');
        console.log(err);
        myo.clearCollection;
      });
    },

    /** 
     * addToCollection() gets the product information
     * from a getProduct() call and then pushes a new
     * product object to the collection array
     */
    addToCollection: function addToCollection(e) {
      myo.getProduct(e.target.dataset.handle).then(function (response) {
        myo.addImageToSummary(response.featured_image, response.title, e.target.dataset.handle);
        myo.updatePrice(response.variants[0].price);
        e.target.closest('.product-card').classList.add('selected');
        e.target.innerText = 'Remove';
        myo.collection.push({
          quantity: 1,
          id: response.variants[0].id,
          properties: {
            'Collection': '' + document.querySelector('#myo-description h1').innerText
          }
        });
      });
    },

    /**
     * clearCollection() clears all images from 
     * the summary cell, resets the price to $0.00,
     * clears the collection array and resets the 
     * button text (for when this is called after an
     * add to cart action)
     */
    clearCollection: function clearCollection() {
      document.querySelector('.selection-thumbs').innerHTML = '';
      document.getElementById('price-total').innerText = '0.00';
      if (myo.collection.length > 0) {
        myo.collection = [];
      }
      document.getElementById('collection-to-cart').innerHTML = 'Add to cart';
      document.querySelectorAll('.product-card.selected').forEach(function (el) {
        el.classList.remove('selected');
        el.querySelector('.collection-list-item .button').innerText = 'Select';
      });
    },

    /**
     * Array for holding all products added or removed from the MYO 
     * Collection.
     */
    collection: [],

    /**
     * Triggers a fetch request to the Shopify AJAX
     * API and returns the json object of the 
     * shopping cart. Not currently used, 
     * but will need to be used to update the price
     * in the header on MYO calls.
     */
    getCart: function getCart() {
      return fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        var cart = document.querySelector('#cart-indicator span.item-count');
        var count = json.item_count > 1 ? 'items' : 'item';
        cart.innerText = '(' + json.item_count + ')';
      });
    },

    /**
     * Triggers a fetch request to the Shopify AJAX
     * API and returns the json object of the 
     * product by its handle.
     */
    getProduct: function getProduct(handle) {
      return fetch('/products/' + handle + '.js', {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      });
    },

    /**
     * init() initializes make your own page
     * adding event listener to section wrapper 
     * by element ID
     */
    init: function init(wrapperId) {
      document.addEventListener('click', function (e) {
        if (e.target.dataset.handle != undefined) {
          e.preventDefault();
          if (e.target.closest('.selected') != null) {
            myo.removeFromCollection(e);
          } else {
            myo.addToCollection(e);
          }
        } else if (e.target.id == 'collection-to-cart') {
          e.preventDefault();
          document.getElementById('collection-to-cart').innerHTML = '' + loader.svg;
          myo.addAllToCart(e);
        }
      });
    },

    /**
     * isMakeYourOwn() checks for a body 
     * data-template-type tag. Used to 
     * determine if script should be initialized.
     */
    isMakeYourOwn: function isMakeYourOwn() {
      var tempType = document.body.dataset.templateType;
      if (tempType == 'make-your-own-grid') {
        return true;
      } else {
        return false;
      }
    },

    /**
     * removeFromCollection() instantiates 
     * removeImageFromSummary() to wipe the
     * image from the summary cell, then get
     * the id of the removed item and remove it from the
     * collection array.
     */
    removeFromCollection: function removeFromCollection(e) {
      myo.removeImageFromSummary(e.target.dataset.handle);
      myo.getProduct(e.target.dataset.handle).then(function (response) {
        var item = myo.collection.indexOf(response.variants[0].id);
        myo.collection.splice(item, 1);
        var newPrice = -1 * response.variants[0].price;
        myo.updatePrice(newPrice);
      });
    },

    /**
     * removeImageFromSummary() targets the image
     * in the summary cell by data-handle and uses
     * that data-handle to set the button state
     * on the product card.
     */
    removeImageFromSummary: function removeImageFromSummary(handle) {
      document.querySelector('.selection-thumbs a[data-handle="' + handle + '"]').parentElement.remove();
      document.querySelectorAll('.product-card.selected').forEach(function (el) {
        var h4 = el.querySelector('[data-handle="' + handle + '"]');
        if (h4) {
          el.classList.remove('selected');
          h4.innerText = 'Select';
        }
      });
    },

    /**
     * updatePrice() checks the current price, 
     * adds (or removes depending on the price passed in)
     * that price to the current price. Price is derived from a 
     * getProduct() call.
     */
    updatePrice: function updatePrice(price) {
      var priceEl = document.getElementById('price-total');
      var currPrice = parseFloat(priceEl.innerText) * 100;
      priceEl.innerText = '' + Math.abs((currPrice + price) / 100).toFixed(2);
    }
  };

  if (myo.isMakeYourOwn()) {
    myo.init();
  }
})();